import { useEffect } from "react";

interface InhouseLoaderProps {
  size?: number;
}

const STROKE_PATH =
  "M3.29399 5.45752C1.89388 12.465 -0.480176 18.2489 3.80075 18.2489C6.32732 18.2489 8.20878 14.3655 10.4377 8.99589C10.8511 7.99993 11.4429 6.2943 12.0452 6.45109C12.6474 6.60787 12.189 8.10888 12.0452 9.79718C11.7755 12.9649 11.3501 14.9205 11.2258 15.7139C10.7588 18.6957 12.2676 18.9472 14.5669 14.1332C16.8046 9.44791 18.3024 8.05583 19.1294 7.66666C20.3508 7.09185 22.4658 7.66666 21.8597 10.5766C21.3242 13.1472 20.7901 15.8276 21.8597 17.0778C22.9293 18.328 24.6073 18.0689 25.5024 17.4743C28.1525 15.7139 28.991 12.2931 28.991 10.5449";

const STYLE_ID = "inhouse-loading-keyframes";

const ensureKeyframes = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes im-trim{0%{stroke-dashoffset:78.2}40%{stroke-dashoffset:0}60%{stroke-dashoffset:0}100%{stroke-dashoffset:78.2}}
    @keyframes im-dot{0%,15%{opacity:0;transform:scale(.4)}32%,68%{opacity:1;transform:scale(1)}85%,100%{opacity:0;transform:scale(.4)}}
  `;
  document.head.appendChild(style);
};

const InhouseLoader = ({ size = 40 }: InhouseLoaderProps) => {
  useEffect(() => {
    ensureKeyframes();
  }, []);

  return (
    <div style={{ width: size, height: size }}>
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: "100%", height: "100%" }}
      >
        <g transform="translate(1.5116 7.488)">
          <path
            d={STROKE_PATH}
            stroke="#0F0F0F"
            strokeWidth="2.72553"
            fill="none"
            style={{
              strokeDasharray: 78.2,
              strokeDashoffset: 78.2,
              animation:
                "im-trim 3.2s cubic-bezier(.65,0,.35,1) infinite",
            }}
          />
        </g>
        <g transform="translate(5.6648 9.4138)">
          <circle
            r="1.86621"
            fill="#0F0F0F"
            style={{
              transformOrigin: "0 0",
              transform: "scale(.4)",
              opacity: 0,
              animation:
                "im-dot 3.2s cubic-bezier(.65,0,.35,1) infinite",
            }}
          />
        </g>
      </svg>
    </div>
  );
};

export default InhouseLoader;
